import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle } = FiIcons;

const FloatingCTA = () => {
  return (
    <motion.div
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ delay: 2, type: 'spring', stiffness: 260, damping: 20 }}
      className="fixed bottom-6 right-6 z-40"
    >
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="bg-primary-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-primary-700 transition-colors duration-200 flex items-center space-x-2"
        onClick={() => window.location.href = 'mailto:elviraviglianopm@gmail.com'}
      >
        <SafeIcon icon={FiMessageCircle} className="h-5 w-5" />
        <span className="hidden sm:block font-medium">Hai dei dubbi? Contattaci!</span>
        <span className="sm:hidden font-medium">Contattaci!</span>
      </motion.button>
    </motion.div>
  );
};

export default FloatingCTA;